import { createSlice } from "@reduxjs/toolkit";
import { getApplications } from "./thunk";

export interface IState {
  Applications: any;
  isApplicationLoading: boolean;
  isApplicationSuccess: boolean;

  error: any;
}

export const initialState: IState = {
  Applications: null,
  isApplicationLoading: false,
  isApplicationSuccess: false,

  error: {},
};

const ApplicationSlice = createSlice({
  name: "Applications",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    //get Application
    builder.addCase(getApplications.pending, (state: IState, action: any) => {
      state.isApplicationLoading = true;
    });
    builder.addCase(getApplications.fulfilled, (state: IState, action: any) => {
      state.Applications = action.payload?.data;
      state.isApplicationSuccess = true;
      state.isApplicationLoading = false;
    });
    builder.addCase(getApplications.rejected, (state: IState, action: any) => {
      state.error = action.payload.error || null;
      state.isApplicationSuccess = false;
      state.isApplicationLoading = false;
    });
  },
});

export default ApplicationSlice.reducer;
